module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mapModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true",
      "data-backdrop": "static"
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "map",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "google-map",
    attrs: {
      "id": _vm.mapName
    }
  })])], 1), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    staticClass: "primary",
    on: {
      "click": _vm.getAddress
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('customer.get-address')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-59c6c8e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MapModal.vue
// module id = 1932
// module chunks = 0